import React, { useEffect, useRef, useState } from 'react';

const LazyVideo = ({ 
  webmSrc, 
  mp4Src, 
  poster, 
  className = '',
  overlayClassName = ''
}) => {
  const videoRef = useRef(null);
  const containerRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { 
        rootMargin: '100px',
        threshold: 0.1 
      }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (isVisible && videoRef.current) {
      videoRef.current.play().catch(() => {
        // Autoplay failed, that's okay
      });
    }
  }, [isVisible]);

  return (
    <div ref={containerRef} className={`lazy-video-container ${className}`}>
      {/* Poster image shown until video loads */}
      {poster && !isLoaded && (
        <img 
          src={poster} 
          alt="Vintage Glass Works Video" 
          className="lazy-video-poster"
          aria-hidden="true"
        />
      )}
      
      {isVisible && (
        <video
          ref={videoRef}
          className={`lazy-video ${isLoaded ? 'loaded' : ''}`}
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          onLoadedData={() => setIsLoaded(true)}
        >
          {webmSrc && <source src={webmSrc} type="video/webm" />}
          {mp4Src && <source src={mp4Src} type="video/mp4" />}
        </video>
      )}
      
      <div className={`lazy-video-overlay ${overlayClassName}`}></div>
    </div>
  );
};

export default LazyVideo;